import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/lock-pdf/components/LockPDFUploader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/PDFToolContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Breadcrumbs.tsx");
